import * as React from "react";

function SvgLeftArrow(props) {
  return (
    <svg width={6.5} height={11} {...props}>
      <g data-name="Grupo 329">
        <path
          fill="#262e3e"
          d="M.176 5.929l4.924 4.9a.609.609 0 00.856 0l.363-.36a.6.6 0 000-.851L2.184 5.5l4.139-4.113a.6.6 0 000-.851l-.362-.36a.609.609 0 00-.856 0L.176 5.075a.6.6 0 000 .854z"
          data-name="Caminho 107"
        />
      </g>
    </svg>
  );
}

export default SvgLeftArrow;

